import axios from "axios";
import { AxiosResponse } from "axios";
import { IBill, IBillResponse } from "../../../../types/IBill";
import { ICategory } from "../../../../types/ICategory";
import { IDocument } from "../../../../types/IDocument";
import { IProposal } from "../../../../types/IProposal";
import { LikeResponse } from "../../../../types/response/LikeResponse";

const api = axios.create({
  withCredentials: true,
  headers: { Authorization: "Bearer " + localStorage.getItem("accessToken") },
});

export default class BillsService {
  static async getAll(query: string): Promise<AxiosResponse<IBillResponse>> {
    return await api.get<IBillResponse>("/api/bills" + query);
  }

  static async getOne(id: number): Promise<AxiosResponse<IBill>> {
    return await api.get<IBill>(`/api/bills/${id}`);
  }

  static async getBillVoteCount(id: number): Promise<AxiosResponse<any>> {
    return await api.get<any>(`/api/bills/${id}/vote-count`);
  }

  static async getBillDocument(
    billId: number,
    documentId: number
  ): Promise<AxiosResponse<IDocument>> {
    return await api.get<IDocument>(
      `/api/bills/${billId}/documents/${documentId}`
    );
  }

  static async getDocumentProposals(
    payload: Object
  ): Promise<AxiosResponse<IProposal[]>> {
    return await api.post<IProposal[]>("/api/proposals/documents", payload);
  }

  static async getBillProposals(billId: number): Promise<AxiosResponse<any>> {
    return await api.get<any>(`/api/proposals/bills/${billId}`);
  }

  static async getDocumentsProposals(
    documentIds: number[]
  ): Promise<AxiosResponse<IProposal[]>> {
    return await api.post<IProposal[]>(`/api/proposals/documents`, documentIds);
  }

  static async saveBillState(billId: number, payload: Object): Promise<any> {
    return await api.patch(`/api/bills/${billId}`, payload);
  }

  static async saveDocumentState(
    billId: number,
    documentId: number,
    payload: Object
  ): Promise<any> {
    return await api.patch(
      `/api/bills/${billId}/documents/${documentId}`,
      payload
    );
  }
  static async addProposalState(payload: Object): Promise<any> {
    return await api.post("/api/proposals", payload);
  }

  static async saveProposalState(
    proposalId: number,
    payload: Object
  ): Promise<any> {
    return await api.patch(`/api/proposals/${proposalId}`, payload);
  }
  static async adminSaveProposalState(
    proposalId: number,
    payload: Object
  ): Promise<any> {
    return await api.patch(`/api/admin/proposals/${proposalId}`, payload);
  }
  static async voteBillState(billId: number, payload: Object): Promise<any> {
    return await api.patch(`/api/bills/${billId}/vote`, payload);
  }

  static async publishProposal(
    proposalId: number,
    userId: number
  ): Promise<any> {
    return await api.patch(`/api/proposals/${proposalId}/publish`, {
      userId: userId,
    });
  }

  static async likeProposal(
    proposalId: number,
    value: -1 | 0 | 1
  ): Promise<AxiosResponse<LikeResponse>> {
    return await api.post(`/api/proposal/${proposalId}/likes`, {
      like: value,
    });
  }

  static async deleteProposal(proposalId: number): Promise<any> {
    return await api.delete(`/api/proposals/${proposalId}`);
  }

  static async getAllCategories(): Promise<AxiosResponse<ICategory[]>> {
    return await api.get<ICategory[]>("/api/bills/categories");
  }

  static async createNewProposal(data): Promise<any> {
    return await api.post("/admin/api/resources/Bill/actions/new", data);
  }
}
